import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

/**
 * Utility class for handling HTTP errors consistently across services
 */
export class HttpErrorHandler {
  /**
   * Extracts error message from HttpErrorResponse with fallback chain
   * @param error The HTTP error response
   * @param fallback The fallback message if no error message is found
   * @returns The extracted error message
   */
  static extractErrorMessage(error: HttpErrorResponse, fallback: string = 'An error occurred'): string {
    return (
      (error.error?.message as string) ||
      (error.error?.details as string) ||
      (error.error?.error?.message as string) ||
      error.message ||
      fallback
    );
  }

  /**
   * Handles HTTP error and returns an Observable that throws an Error
   * @param error The HTTP error response
   * @param fallback Optional fallback message
   * @returns Observable that throws an Error
   */
  static handleError(error: HttpErrorResponse, fallback?: string): Observable<never> {
    const errorMessage = this.extractErrorMessage(error, fallback);
    return throwError(() => new Error(errorMessage));
  }
}
